import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/apex/Navbar";
import { Hero } from "@/components/apex/Hero";
import { About } from "@/components/apex/About";
import { Services } from "@/components/apex/Services";
import { Projects } from "@/components/apex/Projects";
import { ServiceAreas } from "@/components/apex/ServiceAreas";
import { EstimateForm } from "@/components/apex/EstimateForm";
import { Consultation } from "@/components/apex/Consultation";
import { Payments } from "@/components/apex/Payments";
import { Contact } from "@/components/apex/Contact";
import { Footer } from "@/components/apex/Footer";
import { AdminApp } from "@/admin/AdminApp";

const Site = () => (
  <div className="bg-white min-h-screen text-[#0A1F3C] antialiased">
    <Toaster theme="light" position="top-center" richColors />
    <Navbar />
    <main>
      <Hero />
      <About />
      <Services />
      <Projects />
      <ServiceAreas />
      <EstimateForm />
      <Consultation />
      <Payments />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Site />} />
        <Route path="/admin" element={<AdminApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
